import JSON_HEADERS from 'jsonHeaders'
import snakeify from 'lib/snakeify'

export const flushDraft = async (data) => {
  const { uid, imageUrl: _, slug: __, isDirty: ___, isSaved: ____, ...params } = data

  return fetch(`/api/burosfera/vacancies/${uid}/`, {
    method: 'PUT',
    headers: JSON_HEADERS,
    credentials: 'include',
    body: JSON.stringify(snakeify(params)),
  })
}
